import * as React from 'react';

import PopoverGraphic from './assets/popover-graphic.svg';
import RatingGraphic from './assets/rating-graphic.svg';
import WidgetGraphic from './assets/widget-graphic.svg';
import type {LeadRecapsHelpPage} from './help-lead-recaps';

export function getTitle(page: LeadRecapsHelpPage): string {
    switch (page) {
        case 'page-1':
            return 'Welcome to lead recaps and next steps';
        case 'page-2':
            return 'Welcome to lead recaps and next steps';
        case 'page-3':
            return 'Welcome to lead recaps and next steps';
        default:
            return '';
    }
}

export function getBody(page: LeadRecapsHelpPage): React.ReactElement | null {
    switch (page) {
        case 'page-1':
            return (
                <p>
                    <b>Instantly catch up on a lead, and understand what’s next.</b> Nutshell AI
                    reviews complete lead histories, and compares them to your ideal sales process.
                </p>
            );
        case 'page-2':
            return (
                <p>
                    Lead recaps give you a one-line summary on what has happened with a lead so far.
                    And next steps suggest the best steps you can take to move a lead toward a sale.
                </p>
            );
        case 'page-3':
            return (
                <p>
                    We’d love your feedback on how these recommendations are working - please share
                    with the thumbs-up/down buttons!
                </p>
            );
        default:
            return null;
    }
}

export function getGraphic(page: LeadRecapsHelpPage): React.ReactElement | null {
    switch (page) {
        case 'page-1':
            return <PopoverGraphic />;
        case 'page-2':
            return <WidgetGraphic />;
        case 'page-3':
            return <RatingGraphic />;
        default:
            return null;
    }
}
